export default {
  props: {
    modelId: {
      required: false,
    },
    tag: {
      type: String,
      default: 'h1',
    }
  },
  data() {
    return {
      apiEntity: null,
      model: {},
      not_found: false,
      loading: false,
    };
  },
  computed: {
    id() {
      return this.modelId || this.$route.params.id;
    },
    isDeleted() {
      return this.model.IsDeleted === true;
    },
  },
  async mounted() {
    // Skip auto-fetch if component explicitly requests it (via prop or data property)
    // Default to false if not set, so components without skipAutoFetch still fetch normally
    if (this.skipAutoFetch === true) {
      return;
    }
    await this.performAutoFetch();
  },
  methods: {
    async performAutoFetch() {
      await this.fetch(this.id);
      if (this.pageTitle) {
        let pageTitle = this.pageTitle;
        if (typeof this.pageTitle === 'function') {
          pageTitle = this.pageTitle(this.model);
        }
        await this.$store.dispatch('updatePageTitle', pageTitle);
      }
    },
    async fetch(id) {
      if (!this.modelEntity || !id) {
        return;
      }

      try {
        this.loading = true;
        await this.$store.dispatch('updateIsLoading', true);
        const {
          data
        } = await this.modelEntity.get(id);
        this.model = data.data
        await this.$store.dispatch('updateIsDeleted', this.model.IsDeleted || false);
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        await this.$store.dispatch('updateIsLoading', false);
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
    async reloadForm(id) {
      this.model = {};
      await this.fetch(id);
    }
  }
};
